import React from 'react';
import { PageHeader } from 'antd';

const routes = [
  {
    path: '/',
    breadcrumbName: 'Helper',
  },
  {
    path: 'Spacings',
    breadcrumbName: 'Spacings',
  },
];

const Spacings = () => {
  return (
    <>

      <PageHeader title="Spacings - margin , padding" breadcrumb={{ routes }} subTitle="Spacings" style={{ padding: 10 }} />

      <div className="MF_area">
        <ul>
          <li>.mg_{`{type}`}_{`{value}`}</li>
          <li>.pd_{`{type}`}_{`{value}`}</li>
        </ul>
        <ul>
          <li>t : margin-top or padding-top</li>
          <li>b : margin-bottom or padding-bottom</li>
          <li>l : margin-left or padding-left</li>
          <li>r : margin-right or padding-right</li>
        </ul>
        <ul>
          <li>5 unit</li>
          <li>5 ~ 100</li>
        </ul>
      </div>
    </>
  );
}

export default Spacings;
